import { like } from '@/calls/likes';

const likes = {
  namespaced: true,
  state: {
    items: [],
  },
  mutations: {
    setLike(state, id) {
      state.items.push(id);
    },
    removeLike(state, index) {
      state.items.splice(index, 1);
    },
    setLikes(state, items) {
      state.items = items;
    },
    save(state) {
      const userLikes = JSON.stringify(state.items);
      localStorage.setItem('user-likes', userLikes);
    }
  },
  actions: {
    async like({ commit, state }, { event, user }) {
      const index = state.items.indexOf(event);
      let remove = false;

      if (index >= 0) {
        commit('removeLike', index);
        remove = true;
      } else {
        commit('setLike', event);
      }

      const request = await like({
        event,
        user,
        remove
      });

      console.log('request like :', request);

      commit('save');
    }
  }
};

export default likes;
